import React from "react"

import { Col, Row } from "react-bootstrap"
import renderElement from "../../../utils/renderElement"

import "./icon-description-card.scss"

const IconDescriptionCard = ({ icon, title, description }) => {
  return (
    <Col md="4" className="text-center">
      <Row>
        <Col>
          <div className="icon-container mb-2">
            <img src={icon?.url} alt={icon?.alt} />
          </div>
          <h3
            className="mb-2"
            dangerouslySetInnerHTML={renderElement(title)}
          ></h3>
          <p dangerouslySetInnerHTML={renderElement(description)}></p>
        </Col>
      </Row>
    </Col>
  )
}

export default IconDescriptionCard
